import { useQuery } from "@tanstack/react-query";
import { getCategoriesList } from "../actions/products";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories", "list"],
    queryFn: () =>
      getCategoriesList({
        queryParams: {
          fields: "name",
        },
      }),
  });
};
